import _ from "lodash";
import { CapabilitiesMap } from "../ProvisionedDesktopDeviceSettingsRouter";
import { BasicDesktopDeviceSettings } from "../schemas/types";

export const getC10Value = (
  settings: BasicDesktopDeviceSettings,
  path: string[]
) => {
  return _.get(settings, path);
};

export const generateC10String = (accessor: string, addValue = true) => {
  const val = addValue ? ".value" : "";
  return `com.poly.${accessor}${val}`;
};

/*
  This method takes in a capabilitiesMap

  [
    {
      id: "com.poly.audio.noise_block_ai"
      value: true
    }
  ]

  and returns a capabilities query object

  com: {
    poly: {
      audio: {
        noise_block_ai: "true"
      }
    }
  }

*/
export const createC10QueryObj = (
  capabilitiesToUpdate: CapabilitiesMap = []
) => {
  const booleanOptions = ["use_latest"];
  const c10Obj = {};
  const createC10Object = (
    path: string[],
    obj: Record<any, any>,
    value: string
  ) => {
    let key = path[0];
    if (path.length === 1) {
      if (!booleanOptions.includes(key) && typeof value === "boolean") {
        value = value ? "true" : "false";
      }
      obj[key] = value;
    } else {
      if (!obj[key]) {
        obj[key] = {};
      }
      createC10Object(path.slice(1), obj[key], value);
    }
  };

  capabilitiesToUpdate.forEach((capability: { id: string; value: string }) => {
    createC10Object(capability.id.split("."), c10Obj, capability.value);
  });

  return c10Obj;
};
